import React, { useEffect, useState } from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"

import Demo from "../pages/home/demo"
import DemoFormPage from "../pages/form/demoFormPage"
import LoginPage from "../pages/admin/loginPage"
import ListingPage from "../pages/admin/listingPage"
import NotFound from "../pages/notfound/NotFound"

import RouteConfig from "./RouteConfig"
import logo from '../advance-logo.svg';
import SandboxThankyou from "../pages/sandbox/SandboxThankyou"

const AppRoute: React.FC = () => {
  const [token, setToken] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  
  // On app load, check if there's a token in sessionStorage
  useEffect(() => {
    const storedToken = sessionStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
    const storedEmail = sessionStorage.getItem('email');
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  // Handle login and store the token in sessionStorage
  const handleLogin = (token: string, email: string) => {
    setToken(token);
    setEmail(email);
    sessionStorage.setItem('token', token); // Save token in sessionStorage
    sessionStorage.setItem('email', email); // Save email in sessionStorage
  };

  // Handle logout (optional)
  const handleLogout = () => {
    setToken(null);
    setEmail(null);
    sessionStorage.removeItem('token'); // Remove token from sessionStorage
    sessionStorage.removeItem('email'); // Remove email from sessionStorage
  };

  return (
    <Router>
      <div className="demoContainer">
          <img src={logo} alt="Logo" className="logo" />
          <Routes>
            <Route path={RouteConfig.home.path} element={<Demo />} />
            <Route path={RouteConfig.form.path} element={<DemoFormPage />} />
            <Route path={RouteConfig.login.path} element={ token ? <Navigate to={RouteConfig.listing.path} /> : <LoginPage onLogin={handleLogin}/> } />
            <Route path={RouteConfig.listing.path} element={ token ? <ListingPage token={token} adminEmail={email} onLogout={handleLogout}  /> : <Navigate to={RouteConfig.login.path} /> } />
            <Route path={RouteConfig.sandbox.registered.path} element = { <SandboxThankyou /> } />
            <Route path={RouteConfig.sandbox.confirmed.path} element = { <SandboxThankyou />} />            
            <Route path={RouteConfig.notfound.path} element={<NotFound />} />
          </Routes>
      </div>
    </Router>
  )
}

export default AppRoute

/*

*/
